import React from 'react';
import styled from 'styled-components';

export default styled(({ padded, ...rest }) => <div {...rest} />)`
  max-width: 430px;
  width: 100%;
  margin: 0 auto;
  padding: ${({ padded }) => (padded ? '4rem 2rem' : '0')};
`;
